import Vue from "vue"
import "../service/consts.js";
import App from "./App.vue"
import store from "./store"
import "normalize.css"
import "@/assets/style/style.scss"
import "@/assets/style/common.scss"
import "@/assets/style/atomic.css"
import "@/assets/style/transition.css"
import { shit, addShit, removeShit } from "@/code-lab/lib/acss/factory.js"
import VueI18n from "vue-i18n"
import router from "./router.js"
import ELEMENT from "element-ui"
import utils from "@/service/utils.js"
import http$ from "@/service/axios.js"
import svgIcon from "@/code-lab/view/svg-icon.vue"
import HandleBlocklyi18n from "@/service/mapping/blocklyI18n.js"
import HandleCss from "@/service/mapping/handleCssIn.js"
import B from "@/service/webSocket/B.js"
Vue.config.devtools = (process.env.NODE_ENV === "dev");
const _shit = { shit$: shit, addShit$: addShit, removeShit$: removeShit }
const goog = window.goog;

Object.assign(Vue.prototype, { http$ }, { util$: utils }, _shit)
Object.assign(window, { clearAllCookies$: utils.clearAllCookies$ })
window.$isMobile = Vue.prototype.$isMobile = goog.userAgent.MOBILE || goog.userAgent.ANDROID || goog.userAgent.IPAD;

HandleCss({ addShit })
const Cookies = window.Cookies;
let langCode = Cookies.get("langCode") ;
langCode = store.state["multiLanguageStore"].find( item => langCode === item)
const cookieDomain = process.env.VUE_APP_cookie_domain;
if(!langCode){
  langCode = "zh-TW";
  let language = "tw";
  Cookies.set('langCode', langCode, { domain: cookieDomain, expires: 1 })
  Cookies.set('language', language, { domain: cookieDomain, expires: 1 })
}
//i18n国际化
Vue.use(VueI18n)

//全局svg图标组件
Vue.component("svg-icon", svgIcon)

Vue.config.productionTip = false

const requestLangOfMsg = (name = "zh-hant") => {
  const nameObj = {
    "zh-CN": "zh-hans",
    "zh-TW": "zh-hant",
    "ja-JP": "ja",
    "en-US": "en",
    "ko-KR": "ko"
  };
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    let url = "" + process.env.BASE_URL + "static/js/blockly/msg/json/"+ nameObj[name] +".json";
    xhr.open("GET", url);
    xhr.onreadystatechange = event => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        if (/^\{/.test(xhr.responseText)) {
          resolve(xhr.responseText);
        } else {
          reject(event);
        }
      }
    };
    xhr.onerror = err => reject(err);
    xhr.send(null);
  });
}

(async () => {
  const arr = store.state["multiLanguageStore"]
  let blocklyMsg = {}
  await Promise.all(arr.map(mo => requestLangOfMsg(mo)))
  .then(res => arr.forEach((o, i) => blocklyMsg[o] = JSON.parse(res[i]) ) )
  .catch(err => console.error(err))
  const i18n = new VueI18n({
    locale: langCode,
    messages: HandleBlocklyi18n(ELEMENT, blocklyMsg)
  })
 
  //全局element-ui
  Vue.use(ELEMENT, {
    i18n: (key, value) => i18n.t(key, value),
    size: "small",
    zIndex: 2000,
    effect: "dark"
  })

  new Vue({
    router,
    store,
    i18n,
    data: {
      isSocketInited: false
    },
    created () {
      const consoleContant = false
      const returnConsole = (key) => consoleContant ? window.console[key] : () => {}
      const obj = { l$: returnConsole('log'), err$: returnConsole('error') }
      Object.assign(window, obj)
      Object.assign(Vue.prototype, obj)
    },
    beforeCreate() {
      const b$ = new B(this);
      Object.assign(Vue.prototype, { b$, $t: (key, value) => i18n.t(key, value), });
    },
    render: h => h(App)
  }).$mount("#go")
})()
